import api from '../api'

export const getMapClinics = async (campaignId: string) => {
  return api.get(`client/campaign/${campaignId}/clinics`)
}
